export const BULK_EDIT_IDENTIFIER_COLUMNS = [
  "Site",
  "Capacity Year",
  "Status",
  "Program Type",
  "Timeline",
  "LMSC/SC-SC",
  "SC Type",
] as const;

// Identifier columns that are visible by default but can be toggled off via Column Filter
export const BULK_EDIT_OPTIONAL_IDENTIFIER_COLUMNS = [
  "Region",
  "Cluster",
  "Original Launch Year",
] as const;

export const FIELD_GROUP_SITE_DETAILS = "siteDetails";

// Only these columns are sticky (frozen) on scroll — the rest of the identifier columns scroll with the table
export const BULK_EDIT_STICKY_COLUMNS = [
  "Site",
  "Capacity Year",
  "Status",
] as const;

export const BULK_EDIT_MAX_ROWS = 200;
export const BULK_EDIT_PAGE_SIZE = 50;
export const BULK_EDIT_SAVE_BATCH_SIZE = 50;
export const SAVE_TIMEOUT_MS = 30000;

export const BULK_EDIT_SITE_DETAILS_EDITABLE_COLUMNS = [
  "Regional Directors",
  "Sub Regional Mgm",
  "Ops Region",
  "Sub Region",
] as const;

// New "Retrofit Details" editable column group, filterable in Column Filter
export const BULK_EDIT_RETROFIT_DETAILS_EDITABLE_COLUMNS = [
  "Go-Live Date",
  "Start Date",
  "End Date",
] as const;

// Fixed identifier columns that are made editable in place (no column filter entry,
// stay in their existing position/styling in BULK_EDIT_IDENTIFIER_COLUMNS)
export const BULK_EDIT_EDITABLE_IDENTIFIER_COLUMNS = [
  "Status",
  "LMSC/SC-SC",
  "Timeline",
] as const;

export const FIELD_GROUP_BUILDING_ATTRIBUTES = "buildingAttributes";
export const FIELD_GROUP_PRODUCTIVITY = "productivity";
export const FIELD_GROUP_RETROFIT_DETAILS = "retrofitDetails";
